import { i18nMark } from 'lingui-react';

const messages = {
  allRepairCases: i18nMark('All Repair Cases'),
  downtime2Days: i18nMark('Downtime > 2 Days'),
  pastDueFollowUp: i18nMark('Past Due Follow Up'),
  pastDueEtr: i18nMark('Past Due ETR'),
  current: i18nMark('Current'),
  uptimeCases: i18nMark('Uptime Cases'),
  waitingApproval: i18nMark('Waiting Approval'),
  openServiceRequest: i18nMark('Open Service Requests'),
  allAssets: i18nMark('All Assets'),
  highSeverity: i18nMark('High Severity'),
  mediumSeverity: i18nMark('Medium Severity'),
  maintenanceOverdue: i18nMark('Maintenance Overdue'),
  maintenanceDue: i18nMark('Maintenance Due'),
  maintenanceCurrent: i18nMark('Maintenance Current'),
};

export default messages;



// WEBPACK FOOTER //
// ./redux/app/messages.js